import { ApplicationConfig } from '@angular/core';

import { withAuthLibrary } from '@web-bankir/auth';
import { withSharedLibrary } from '@web-bankir/shared';
import { createApplicationConfig } from '@web-bankir/shared/helpers/application-config';
import { withApplicationRouterConfig } from '@web-bankir/shared/helpers/application-config/router';
import { withServiceWorker } from '@web-bankir/shared/helpers/application-config/service-worker';
import { withStoreConfig } from '@web-bankir/shared/helpers/application-config/store';
import { withBannersFeature } from '@web-bankir/shared/helpers/banner-place-config';
import { routes } from './app.routes';
import { BANNER_PLACE_MAP } from './services/banner-place/constants/banner-place-map.const';

export const appConfig: ApplicationConfig = createApplicationConfig(
  withSharedLibrary(),
  withAuthLibrary(),
  withApplicationRouterConfig(routes),
  withStoreConfig([], { storage: { namespace: 'wb-auth', keys: ['Consents', 'Auth'] } }),
  withServiceWorker(),
  withBannersFeature(BANNER_PLACE_MAP),
)
